<template>
  <span>{{categoryTxt}}</span>
</template>
<script>

export default {
  name: 'category-txt',
	props: {
    category: {
      type: Object,
      default: null
    },
    specificCategory: {
      type: Object,
      default: null
    }
	},
  data() {
    return {

    };
  },components: {

  },
	methods: {

	},
	computed: {
    categoryTxt () {
      let cat = null;

      if (this.category != null) {
        cat = this.category.name;
      }

      if (this.specificCategory != null) {
        if (cat != null) {
          cat += ' - ';
        }
        cat += this.specificCategory.name;
      }

      return cat;
    },
	},
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';





</style>
